(function ($, window, document) { // jQuery wrapper

    // Menu Functions
    // pagination = {
    var pagination = {

        selectors: {
            block: "",
            container: "",
            filter: "",
            button: "",
            button_container: "",
        },


        block: "",
        container: "",
        filter: "",
        button: "",
        button_container: "",

        init: function (args) {
            pagination.selectors.block = args.block;
            pagination.selectors.container = args.container;
            pagination.selectors.filter = args.filter;
            pagination.selectors.button = args.button;
            pagination.selectors.button_container = args.button_container;
            pagination.selectors.search_input = args.search_input;


            pagination.block = $(pagination.selectors.block);
            pagination.container = $(pagination.selectors.container);
            pagination.filter = $(pagination.selectors.filter);
            pagination.button = $(pagination.selectors.button);
            pagination.button_container = $(pagination.selectors.button_container);
            pagination.search_input = $(pagination.selectors.search_input);

            window.pagination.current_container = "";

            handlePagination();
            handleFilter();
        },
        filterPosts: function(dataArgs){
            queryAndReplace(dataArgs);
        }

    };


    function handlePagination() {
        window.pagination.block.on('click', window.pagination.selectors.button, function (event) {
            var _this = $(this);

            if (_this.hasClass('s-disabled')) {
                return;
            }

            _this.addClass('s-disabled');

            event.preventDefault();
            var post_type = _this.attr('data-post-type');
            var page = parseInt(_this.attr('data-page'));
            var per_page = parseInt(_this.attr('data-per-page'));
            var max_page = parseInt(_this.attr('data-max-page'));
            var offset = parseInt(_this.attr('data-offset'));
            var tax = _this.attr('data-tax');
            var term = _this.attr('data-term');


            if (!_this.hasClass('active')) {
                _this.addClass('active');
                window.pagination.container.addClass('active');

                if (page >= max_page) {
                    _this.addClass("s-hidden");
                }
            } else {

                page++;

                var dataArgs = {
                    action: 'atb_ajax_pagination',
                    post_type: post_type,
                    page: page,
                    per_page: per_page,
                    offset: offset,
                    tax: tax,
                    term: term,
                }
                $.ajax({
                    url: pagedata.ajaxurl,
                    type: 'post',
                    data: dataArgs,
                    success:  function(raw_results) {
                        updateResults(raw_results, page, max_page, _this);
                    }
                });
            }
        });
    }


    function handleFilter() {
        window.pagination.block.on('click', window.pagination.selectors.filter, function (event) {
            var _this = $(this);
            event.preventDefault();

            window.pagination.current_container = _this.parents(window.pagination.selectors.block).find(window.pagination.selectors.container);



            _this.addClass('active').siblings().removeClass('active');
            var dataArgs = {
                action: 'atb_ajax_filter',
                post_type: _this.attr('data-post-type'),
                per_page: parseInt(_this.attr('data-per-page')),
                project_status: _this.attr('data-project-status'),
                offset: parseInt(_this.attr('data-offset')),
                tax: _this.attr('data-tax'),
                term: _this.attr('data-term'),
                pagination_text: _this.attr('data-pagination-text')
            };
            queryAndReplace(dataArgs);
        });
        window.pagination.block.on('change', '.j-pagination--filters__select', function (event) {
            var _this = $(this);
            event.preventDefault();
            window.pagination.current_container = _this.parents(window.pagination.selectors.block).find(window.pagination.selectors.container);

            4
            var dataArgs = {
                action: 'atb_ajax_filter',
                post_type: _this.attr('data-post-type'),
                per_page: parseInt(_this.attr('data-per-page')),
                project_status: _this.attr('data-project-status'),
                offset: parseInt(_this.attr('data-offset')),
                tax: _this.attr('data-tax'),
                term: _this.val(),
                pagination_text: _this.attr('data-pagination-text')
            };
            queryAndReplace(dataArgs);
        });
    }


    function queryAndReplace(dataArgs) {
        $.ajax({
            action: 'atb_ajax_filter',
            url: pagedata.ajaxurl,
            type: 'post',
            data: dataArgs,
            success: function(raw_results) {
                replaceResults(raw_results);
            }
        });
    }

    function replaceResults(raw_results){
        var results = JSON.parse(raw_results);
        var posts = results.posts;
        var button = results.button;

        window.pagination.current_container.html(posts);
        $(window.pagination.button_container).html(button);
    }
    function updateResults(raw_results, page, max_page, _this){
        $(raw_results).appendTo(window.pagination.container);
        _this.attr('data-page', page);
        _this.removeClass('s-disabled');
        if (page >= max_page) {
            _this.addClass("s-hidden");
        }
    }
    // Set pagination to be accesible from window.pagination
    window.pagination = pagination;

}(window.jQuery, window, document)); // End of jQuery wrapper






